<template>
  <div
    :class="{error: item.isValidate === false, success: item.isValidate === true}"
    class="order-user-info-item">
    <div class="order-user-info-item_title">{{ item.name }}</div>
    <label
      :for="item.code"
      class="order-user-info-item_label">
      <input
        :value="item.value"
        placeholder="+7 (___) ___ __ __"
        :id="item.code"
        v-input-mask
        data-inputmask-mask="+7 (999) 999 99 99"
        class="order-user-info-item_input"
        @change="onChange">
      <div
        class="order-user-info-item_clear-wrapper"
        @click="clear">
        <svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M348.994 102.946L250.04 3.993c-5.323-5.323-13.954-5.324-19.277 0l-153.7 153.701 118.23 118.23 153.701-153.7c5.323-5.322 5.323-13.953 0-19.278zM52.646 182.11l-41.64 41.64c-5.324 5.322-5.324 13.953 0 19.275l98.954 98.957c5.323 5.322 13.954 5.32 19.277 0l41.639-41.641L52.646 182.11zM150.133 360h191.634v-28.051H182.806z"/></svg>
      </div>
    </label>
    <div class="order-user-info-item_validate-text">
      {{ getValidateText }}
    </div>
  </div>
</template>

<script>
  import isEmpty from 'lodash/isEmpty'
  import axios from 'axios'

  export default {
    name: 'AccountPhone',
    props: {
      item: {
        type: Object,
        default: () => {
        }
      }
    },
    data: function () {
      return {
        errorText: 'Не верно'
      }
    },
    computed: {
      getValidateText: function () {
        if (this.item.isValidate === true) {
          return 'Верно'
        } else {
          return this.errorText
        }
      }
    },
    methods: {
      onChange: function (e) {
        this.changeValue(e.target.value)
      },
      changeValue: async function (value) {
        let isValidate = this.validate(value)
        this.errorText = 'Неверный формат'
        if (isValidate) {
          const response = await axios.post('/order/isHavePhone', {
            phone: value
          })
          isValidate = isValidate && !response.data.isHave

          if (response.data.isHave) {
            this.errorText = 'Номер телефона уже существует'
          }
        }

        this.$emit('onUpdate', Object.assign({}, this.item, {
          value: value,
          isValidate: isValidate
        }))
      },
      clear: function () {
        this.changeValue('')
      },
      validate: function (value) {
        return !isEmpty(value) && value.replace('_', '').length === 18
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/UserInfo/AccountPhone.vue